var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406.5 166.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,151.1c-13.3,10.5-31.1,15.8-48.2,15.8s-42.6-5.2-60.5-19.8l19.8-33.2c11,9,24.1,17.3,39.2,17.3s20.5-3.1,20.5-14.2-16.4-12.2-25.9-14.6c-20.5-5.2-45.9-12.1-45.9-49.1S32.2,0,66.2,0s38.9,7.9,54,15.9l-18.8,31.3c-8.7-5.6-22.7-8.9-29.3-8.9s-18.5,2.3-18.5,11.1,10.3,11,19.6,13.5c0,0,11.5,2.5,16.3,4.1,21.1,6.9,36.8,14.3,36.8,42.4s-4,31.1-17.6,41.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.4,3.2h-70.3v158.9h45.3v-52.4h23c40,0,53-23,53-54.1S247.8,3.2,207.4,3.2ZM185.8,74.9h-3.5v-37.1h3.5c16.1,0,29.8,0,29.8,18.6s-14.8,18.6-29.8,18.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,3.8h-67.1v158.9h67.1c43.9,0,71-35.1,71-79.7S379.6,3.8,335.5,3.8ZM318.1,125.7h-4.9V40.9h5.3c26.5,0,42.6,17.3,42.6,41.6s-18.4,43.3-43,43.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.38f71cbccc2dc4ebcaeb3e828c4a3216.svg";
export { ForwardRef as ReactComponent };